import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';
import { Button } from './ui';

const NotFoundWrap = styled.div`
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 24px;
  text-align: center;
  font-family: 'Inter', sans-serif;
`;

const NotFoundCode = styled.div`
  font-size: 80px;
  font-weight: 900;
  color: #082189;
  line-height: 1;
`;

const NotFoundTitle = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 800;
  color: #111827;
`;

const NotFoundText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  max-width: 380px;
`;

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <NotFoundWrap>
        <NotFoundCode>404</NotFoundCode>
        <NotFoundTitle>Page not found</NotFoundTitle>
        <NotFoundText>
          The page you're looking for doesn't exist or may have moved.
        </NotFoundText>
        <Button onClick={() => navigate('/')}>← Back to Home</Button>
      </NotFoundWrap>
      <Footer />
    </>
  );
};

export default NotFoundPage;
